import BaseClient from '../BaseClient';
import type {
    CreateWorkflow,
    CreateWorkflowComment,
    StopMode,
    UpdateWorkflow,
    UpdateWorkflowComment,
    WorkflowsClientInterface,
} from './workflowsClient.types';
import type { WorkflowDocumentInput } from '~/types/workflow.types';

export default class CorporateWorkflowsClient extends BaseClient implements WorkflowsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getWorkflows() {
        const url = `/api/v3/teams/${this.teamId}/workflows`;
        return this.makeCoreApiRequest(url);
    }

    getWorkflow(workflowId: number) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}`;
        return this.makeCoreApiRequest(url);
    }

    createWorkflow(input: CreateWorkflow) {
        const url = `/api/v3/teams/${this.teamId}/workflows`;
        return this.makeCoreApiRequest(url, 'post', input);
    }

    updateWorkflow(workflowId: number, input: UpdateWorkflow) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}`;
        return this.makeCoreApiRequest(url, 'put', input);
    }

    archiveWorkflow(workflowId: number, mode?: StopMode) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}/archive`;
        return this.makeCoreApiRequest(url, 'post', mode ? { mode } : {});
    }

    getWorkflowVersions(workflowId: number) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}/versions`;
        return this.makeCoreApiRequest(url);
    }

    getWorkflowVersion(workflowId: number, version: number) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}/versions/${version}`;
        return this.makeCoreApiRequest(url);
    }

    updateWorkflowVersion(workflowId: number, version: number, input: WorkflowDocumentInput) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}/versions/${version}`;
        return this.makeCoreApiRequest(url, 'put', input);
    }

    publishWorkflowVersion(workflowId: number, version: number, mode?: StopMode) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}/versions/${version}/publish`;
        return this.makeCoreApiRequest(url, 'post', mode ? { mode } : {});
    }

    terminateWorkflowVersion(workflowId: number, version: number) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}/versions/${version}/terminate`;
        return this.makeCoreApiRequest(url, 'post');
    }

    getWorkflowOccupancy(workflowId: number) {
        const url = `/api/v3/teams/${this.teamId}/workflows/${workflowId}/occupancy`;
        return this.makeCoreApiRequest(url);
    }

    getWorkflowComments() {
        const url = `/api/v3/teams/${this.teamId}/workflow-comments`;
        return this.makeCoreApiRequest(url);
    }

    createWorkflowComment(input: CreateWorkflowComment) {
        const url = `/api/v3/teams/${this.teamId}/workflow-comments`;
        return this.makeCoreApiRequest(url, 'post', input);
    }

    updateWorkflowComment(commentId: number, input: UpdateWorkflowComment) {
        const url = `/api/v3/teams/${this.teamId}/workflow-comments/${commentId}`;
        return this.makeCoreApiRequest(url, 'put', input);
    }

    deleteWorkflowComment(commentId: number) {
        const url = `/api/v3/teams/${this.teamId}/workflow-comments/${commentId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}
